import Vue from "vue";

import DigitalCatalogList from "./DigitalCatalogList.vue";

export function load() {
    const selector = "digital-catalog-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(DigitalCatalogList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}